<template lang="pug">
  b-container.pt-2
    h4.mb-3 Create new account
    b-card
      form.mt-3(@submit.prevent='onSubmit')
        .row
          .col-md-6
            b-form-group
              label Firstname
              b-form-input(name='firstname', type='text', v-model='inputForm.firstname', required='', placeholder='firstname', autocomplete="fname")
          .col-md-6
            b-form-group
              label Lastname
              b-form-input(name='lastname', type='text', v-model='inputForm.lastname', required='', placeholder='lastname', autocomplete="lname")
          .col-md-6
            b-form-group
              label Phone
              b-form-input(type='text', v-model='inputForm.phone', required='', placeholder='number', autocomplete="tel")
          .col-md-6
            b-form-group
              label Email
              b-form-input(type='email', v-model='inputForm.email', required='', placeholder='email', autocomplete="email")
          .col-md-6
            b-form-group
              label Password
              b-form-input(type="password", name="password", v-model="inputForm.password", required='', pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
          .col-md-6
            b-form-group
              label Repeat
              b-form-input(type="password", name="password2", v-model="passwordRepeat", required='', pattern="(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}")
          .col-md-3
            b-form-group
              label Type
              b-form-radio-group.d-block(:options="accountTypes", buttons="", button-variant="outline-secondary", v-model="inputForm.type")
        b-button(type="submit", variant='primary')
          loader(size="sm")
          span Submit
</template>

<script>
import { mapState, mapActions } from 'vuex';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'CreateAccount',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      inputForm: {
        firstname: 'Jens',
        lastname: 'Kwaremont',
        phone: '0922222222',
        email: 'staff@test.com',
        password: '',
        type: 'staff',
      },
      passwordRepeat: '',
    };
  },
  computed: {
    ...mapState('account', ['staffAccounts', 'accountTypes']),
  },
  methods: {
    ...mapActions('account', ['addStaffAccount']),
    ...mapActions('alert', ['error']),
    onSubmit(evt) {
      evt.preventDefault();
      if (this.inputForm.password !== this.passwordRepeat) {
        this.error('Passwords don\'t match');
      } else {
        this.addStaffAccount(this.inputForm);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input:disabled {
    border: none !important;
    background: transparent;
    color: gray;
}
</style>



// WEBPACK FOOTER //
// src/components/views/CreateAccount.vue